
import i18n from "../../../../i18n";
const IncidentID = i18n.t('manageAutomation.IncidentID');
const AssignedTo = i18n.t('manageAutomation.AssignedTo');
const IncidentStatus = i18n.t('manageAutomation.IncidentStatus');
const Priority = i18n.t('manageAutomation.Priority');
const AlertStatus = i18n.t('manageAutomation.AlertStatus');
const JobID = i18n.t('manageAutomation.JobID');
const Severity = i18n.t('manageAutomation.Severity');
const Rating = i18n.t('manageAutomation.Rating');
const ManagedEntity = i18n.t('manageAutomation.ManagedEntity');
const AlertName = i18n.t('manageAutomation.AlertName');
const AlertCount = i18n.t('manageAutomation.AlertCount');
const UpdatedOn = i18n.t('manageAutomation.UpdatedOn');
const Client = i18n.t('manageAutomation.Client');
const Technology = i18n.t('manageAutomation.Technology');
const Category = i18n.t('manageAutomation.Category');
const SubCategory = i18n.t('manageAutomation.SubCategory');
const SLADueIn = i18n.t('manageAutomation.SLADueIn');
const Franchise = i18n.t('manageAutomation.Franchise');
const IncidentURL = i18n.t('manageAutomation.IncidentURL');
const SysId = i18n.t('manageAutomation.SysId');
const SID = i18n.t('manageAutomation.SId');
const ImpactedKPI = i18n.t('manageAutomation.ImpactedKPI');
const Impact = i18n.t('manageAutomation.Impact');


const ALERT_HEADERS = [
  {
    key: 'incidentId',
    header: IncidentID,
    hidden: false,
    optional: false
  },
  {
    key: 'assigned_to',
    header: AssignedTo,
    hidden: false,
    optional: false
  },
  {
    key: 'incidentStatus',
    header: IncidentStatus,
    hidden: false,
    optional: false
  },
  {
    key: 'priority',
    header: Priority,
    hidden: false,
    optional: false
  },
  {
    key: 'SLA_due_in',
    header: SLADueIn,
    hidden: true,
    optional: true
  },
  {
    key: 'category',
    header: Category,
    hidden: true,
    optional: true
  },
  {
    key: 'subCategory',
    header: SubCategory,
    hidden: true,
    optional: true
  },
  {
    key: 'entity',
    header: ManagedEntity,
    hidden: false,
    optional: false
  },
  {
    key: 'alertName',
    header: AlertName,
    hidden: false,
    optional: false
  },
  // {
  //   key: 'rating',
  //   header: Rating,
  //   hidden: false,
  //   optional: false
  // },
  // {
  //   key: 'job_id',
  //   header: JobID,
  //   hidden: true,
  //   optional: true
  // },

  {
    key: 'client',
    header: Client,
    hidden: false,
    optional: false
  },
  {
    key: 'franchise',
    header: Franchise,
    hidden: true,
    optional: false
  },
  {
    key: 'aiops',
    header: 'aiops',
    hidden: true,
    optional: false
  },
  {
    key: 'alertCount',
    header: AlertCount,
    hidden: false,
    optional: false
  },
  // {
  //   key: 'impactedKpi',
  //   header: ImpactedKPI,
  //   hidden: true,
  //   optional: true
  // },
  // {
  //   key: 'impact',
  //   header: Impact,
  //   hidden: true,
  //   optional: true
  // },
  // {
  //     key: 'technology',
  //     header: Technology,
  //     hidden: true,
  //     optional: true
  // },
  // {
  //   key: 'alertStatus',
  //   header: AlertStatus,
  //   hidden: true,
  //   optional: true
  // },

  {
    key: 'incidentURL',
    header: IncidentURL,
    hidden: true,
    optional: false
  },
  {
    key: 'sysId',
    header: SysId,
    hidden: true,
    optional: false
  },
  // {
  //   key: 'sid',
  //   header: SID,
  //   hidden: false,
  //   optional: false
  // },
  {
    key: 'veracity',
    header: 'veracity',
    hidden: true,
    optional: false
  },

  {
    key: 'username',
    header: 'User Name',
    hidden: false,
    optional: false
  },
  {
    key: 'updatedOn',
    header: UpdatedOn,
    hidden: false,
    optional: false
  }

];
export default ALERT_HEADERS;

